module.exports = __webpack_public_path__ + "img/engine-oil-vice-wiper.adec87ba.png";